import { useEffect, useState } from "react";
import * as http from "../../../../../utils/http";
import { MyAccountStoreProduct, MyAccountStoreProductsResponse } from "../types";

interface Input {
  storeKey: string;
  country: string;
  enabled: boolean;
}

interface State {
  loading: boolean;
  error: boolean;
  products: MyAccountStoreProduct[];
  ruleApplied: string;
  prioritizedProductIDs: number[];
}

const INITIAL_STATE: State = {
  loading: true,
  error: false,
  products: [],
  ruleApplied: "NONE",
  prioritizedProductIDs: [],
};

export const useMyAccountStoreProducts = (input: Input): State => {
  const { storeKey, country, enabled } = input;
  const [state, setState] = useState<State>(INITIAL_STATE);

  useEffect(() => {
    if (!enabled) return;

    setState((prev) => ({ ...prev, loading: true, error: false }));

    http
      .getFromServer(
        `${country}/account/store/${storeKey}/products`,
        [http.MIDDLEWARES.CUSTOMER_ID, http.MIDDLEWARES.CART_ORDER],
      )
      .then((response: any) => {
        const data: MyAccountStoreProductsResponse = response?.data ?? {
          store: { key: storeKey },
          products: [],
          personalization: { ruleApplied: "NONE", prioritizedProductIDs: [] },
        };
        setState({
          loading: false,
          error: false,
          products: data.products ?? [],
          ruleApplied: data.personalization?.ruleApplied ?? "NONE",
          prioritizedProductIDs: data.personalization?.prioritizedProductIDs ?? [],
        });
      })
      .catch((err: any) => {
        (window as any).clientLogger?.error?.("MyAccountStore: failed to load products", err);
        setState({ ...INITIAL_STATE, loading: false, error: true });
      });
  }, [storeKey, country, enabled]);

  return state;
};
